import {
  BudgetImage,
  CommunicationImage,
  DashboardImage,
  ProcurementImage,
  QualityManagementImage,
} from "assets/images";
import { Feature } from "components/containers/constant";

export const features: Feature[] = [
  {
    name: "Dashboard",
    image: DashboardImage,
    description:
      "Deploy capital to build projects, with tools that lower risk, increase efficiency, enhance oversight, and ensure stakeholder accountability.",
  },
  {
    name: "Cost Control",
    image: BudgetImage,
    description:
      "Use our budgeting and book keeping tool to track every kobo and match expenditure to progress",
  },
  {
    name: "Procurement Management",
    image: ProcurementImage,
    description:
      "Get granular details of material procurement and consumption on projects.",
  },
  {
    name: "Quality Management",
    image: QualityManagementImage,
    description:
      "Our robust check-listing feature ensures that all tasks are delivered to the right quality specification.",
  },
  {
    name: "Communication",
    image: CommunicationImage,
    description:
      "keep every stakeholder in the loop with real time communication and reporting.",
  },
];
